import '../../index.css';
var styles = {
  "popoverMainContent": "bp_popover_module_popoverMainContent--46d8d",
  "popoverContentContainer": "bp_popover_module_popoverContentContainer--46d8d",
  "popoverCard": "bp_popover_module_popoverCard--46d8d",
  "popoverMainContentOuterContainer": "bp_popover_module_popoverMainContentOuterContainer--46d8d",
  "popoverMainContentInnerContainerPadding": "bp_popover_module_popoverMainContentInnerContainerPadding--46d8d",
  "popoverFooter": "bp_popover_module_popoverFooter--46d8d",
  "popoverFooterTopBorder": "bp_popover_module_popoverFooterTopBorder--46d8d"
};
export { styles as default };